<template>
	<div class="nav-bar">
		<div class="nav-bar-content h-full flex items-center p-3">
			<div class="nav-bar-item flex flex-1 justify-center">
				<img class="logo mr-auto" @click.prevent="toVlogHome" :src="logoUrl" />
			</div>
			<div class="nav-bar-item flex flex-1 justify-center">
				<div class="menu ml-2" @click.prevent="toVlogHome">
					<span class="title text-ml font-semibold">官网Vlog</span>
				</div>
			</div>

			<div class="nav-bar-item flex flex-1 justify-center">
				<div class="website-link ml-auto" v-if="websiteUrl?.length > 0">
					<a :href="websiteUrl" target="_blank" class="website-anchor text-sm"
						>访问官网</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		logoUrl: {
			type: String,
			default: "",
		},
		websiteUrl: {
			type: String,
			default: "",
		},
	},
	data() {
		return {};
	},
	methods: {
		toVlogHome() {
			this.$router.push({ path: "/vlog" });
		},
	},
	name: "NavBar",
	components: {},
};
</script>
<style scoped>
.nav-bar {
	height: 54px;
	background: white;
}
.logo {
	display: block;
	max-height: 28px;
	max-width: 88px;
	object-fit: contain;

	max-height: 38px;
	max-width: 90%;
}
.logo-container .logo {
	display: inline-block;
}
.logo-container .menu {
	display: inline-block;
}
.nav-bar-content {
}
.website-link {
	font-size: 15px;
}
.nav-bar {
	border-bottom: 0.5px solid #dddddd;
}
</style>
